"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerShop = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.ContainerShop = styled_components_1.default.div `
  display: flex;
  gap: 22px;
  align-items: center;
  justify-content: end;
  width: 290px;
`;
